export default __webpack_public_path__ + "static/media/comunidades_estudantes.bd47f56b.jpg";